<div    *ngIf="(loadersObs | async)?.length" 
        class="position-top-left full-stretch z-10000 background-white opacity-75"
>
    <div class="root-loader-container flex-column flex--align-center">

        <mat-progress-spinner [strokeWidth]="5" [diameter]="75" [value]="50" mode="indeterminate" color="primary"></mat-progress-spinner>
        
        <div>
            <h6 class="mat-headline-6 margin-none" *ngFor="let display of loaderDisplaysObs | async">{{ display }}</h6>
        </div>

    </div>
</div>